import { render, staticRenderFns } from "./Domain.vue?vue&type=template&id=fa42d9be&"
import script from "./Domain.vue?vue&type=script&lang=ts&"
export * from "./Domain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports